<template>
  <v-dialog :value="value" persistent width="350">
    <v-card>
      <v-container class="pa-6">
        <v-row justify="center" dense>
          <span class="font-weight-medium">
            {{selectedVariance.include_flag ? 'Include': 'Exclude'}} Store #{{selectedVariance.store_number}} from all items?
          </span>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-spacer/>
        <v-btn rounded>
          No
        </v-btn>
        <v-btn class="primary white--text" rounded>
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { displayHelpers } from '@/mixins/display-helpers'

export default {
  name: 'ItemStoreMgmt',

  props: {
    value: Boolean,
    selectedVarianceList: Array,
    selectedVariance: Object
  },

  mixins: [displayHelpers]
}
</script>
